import { type ComponentType } from 'react';
import {
  type GroupBase,
  type InputProps,
  type SelectComponentsConfig,
} from 'react-select';

import { SelectInput } from '../Select/SelectInput';

function HiddenSelectComponent() {
  return null;
}

const defaultComponents = {
  IndicatorSeparator: HiddenSelectComponent,
  Input: SelectInput as ComponentType<
    InputProps<unknown, boolean, GroupBase<unknown>>
  >,
};

export function getSelectComponents<
  TOption,
  TIsMulti extends boolean = boolean,
  TGroup extends GroupBase<TOption> = GroupBase<TOption>,
>(
  overrides?: SelectComponentsConfig<TOption, TIsMulti, TGroup>,
): SelectComponentsConfig<TOption, TIsMulti, TGroup> {
  return {
    ...(defaultComponents as unknown as SelectComponentsConfig<
      TOption,
      TIsMulti,
      TGroup
    >),
    ...overrides,
  };
}
